import React from 'react';
import { CKEditor } from 'ckeditor4-react';

const MathEditor = () => {
    const editorConfig = {
        extraPlugins: 'ckeditor_wiris',
        allowedContent: true,
        pasteFilter: null,  // allow all pasted content
        forcePasteAsPlainText: false,
        toolbarGroups: [
            {
                name: 'clipboard',
                groups: ['clipboard', 'undo']
            },
            {
                name: 'editing',
                groups: ['find', 'selection', 'spellchecker']
            },
            {
                name: 'links'
            },
            {
                name: 'insert'
            },
            {
                name: 'forms'
            },
            {
                name: 'tools'
            },
            {
                name: 'document',
                groups: ['mode', 'document', 'doctools']
            },
            {
                name: 'colors'
            },
            {
                name: 'others'
            },
            {
                name: 'about'
            },
            '/',
            {
                name: 'basicstyles',
                groups: ['basicstyles', 'cleanup']
            },
            {
                name: 'paragraph',
                groups: ['list', 'indent', 'blocks', 'align', 'bidi']
            },
            {
                name: 'styles'
            }
        ],
    };

    const onBeforeLoad = (CKEDITOR) => {
        CKEDITOR.plugins.addExternal(
            'ckeditor_wiris',
            'https://ckeditor.com/docs/ckeditor4/4.14.0/examples/assets/plugins/ckeditor_wiris/',
            'plugin.js'
        );
    };
    var init = `<p><math xmlns="http://www.w3.org/1998/Math/MathML"><mfrac><mn>2</mn><mn>5</mn></mfrac><mo>+</mo><mfrac><mn>3</mn><mn>5</mn></mfrac><mo>=</mo><mn>16</mn></math></p>
<p><math xmlns="http://www.w3.org/1998/Math/MathML" class="wrs_chemistry"><msub><mi mathvariant="normal">H</mi><mn>2</mn></msub><msub><mi>SO</mi><mn>4</mn></msub></math>
</p>
<p><math xmlns="http://www.w3.org/1998/Math/MathML" display="block">
    <mrow>
        <mrow>
            <mo>&#x222B;</mo>
            <msub>
                <mn>0</mn>
            </msub>

            <msup>
                <mo>&#x221E;</mo>
                <mn></mn>
            </msup>
            <mfrac>
                <msup>
                    <mi>x</mi>
                    <mn>2</mn>
                </msup>
                <mrow>
                    <msup>
                        <mi>e</mi>
                        <mi>x</mi>
                    </msup>
                    <mo>&#x2212;</mo>
                    <mn>1</mn>
                </mrow>
            </mfrac>
            <mo>&#xA0;</mo>
            <mi>dx</mi>
        </mrow>
        <mo>=</mo>
        <mfrac>
            <msup>
                <mi>&#x03C0;</mi>
                <mn>4</mn>
            </msup>
            <mn>15</mn>
        </mfrac>
    </mrow>
</math></p>`

    return (
        <div className="App">
            <h2>Using CKEditor 4 in React</h2>
            <CKEditor
                initData={init}
                config={editorConfig}
                onBeforeLoad={onBeforeLoad}
            />
        </div>
    );
};

export default MathEditor;
